import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
})
export class AddressComponent implements OnInit {

  required: boolean = true;
  alertText: boolean = false;
  public isDisabled = false;
  openCategMobile: boolean = false;
  openCategMobileDom: boolean = false;
  searchCatMobile: any = '';
  @ViewChild(IonModal) modalx: IonModal;
  selectCateg: boolean = false;
  hslCatx: any;
  openCateg: boolean = false;
  openAutoCom: boolean = false;
  searchCat: any = '';
  load: boolean = false;
  region: any;
  reg: any;
  dataAlamat: any = {};
  dataAlamatString: any;
  dataAlamatStringDom: any;

  kelurahandom: any = '';
  kecamatandom: any = '';
  kotadom: any = '';
  provinsidom: any = '';
  kodeposdom: any = '';
  rtdom: any = '';
  rwdom: any = '';
  alamatdom: any = '';
  kelurahanIddom: any = '';

  kelurahanktp: any = '';
  kecamatanktp: any = '';
  kotaktp: any = '';
  provinsiktp: any = '';
  kodeposktp: any = '';
  rtktp: any = '';
  rwktp: any = '';
  alamatktp: any = '';
  kelurahanIdktp: any = '';

  @Input() value: any = '';
  @Input() dataAlamatKTP: any = '';
  @Input() tipe: any = 'satuAlamat';
  @Input() dataEdit: any = {};

  dataAlamatJSON: any = {};
  dataEditJSON: any = '';
  sesuaiktp: boolean = false;
  valuee: any = 0.2;
  dataAlamatDom: any = {};
  dataAlamatKirim: any = '';
  dataAlamatDomString

  @Output() dataEvent = new EventEmitter<any>();


  constructor(
    public api: ApiService,
    public util: UtilService
  ) { }

  ngOnInit() {
    this.getAllKecamatan();
    if(this.dataAlamatKTP !== ''){
      this.dataAlamatJSON = JSON.parse(this.dataAlamatKTP);
      // console.log('dataAlamatJSON',this.dataAlamatJSON)
      this.kelurahanktp = this.dataAlamatJSON.desa_name;
      this.kecamatanktp = this.dataAlamatJSON.kec_name;
      this.kotaktp = this.dataAlamatJSON.kab_name;
      this.provinsiktp = this.dataAlamatJSON.prov_name;
      this.kodeposktp = this.dataAlamatJSON.kode_pos;
      this.kelurahanIdktp = this.dataAlamatJSON.desa_id;
    }

    if(this.dataEdit !== ''){
      try {
        this.dataEditJSON = JSON.parse(this.dataEdit);
      // console.log('tipe',this.tipe)
      if(this.tipe == 'satuAlamat'){
        this.kelurahanktp = this.dataEditJSON.ktp_subdistricts_name;
        this.kelurahanIdktp = this.dataEditJSON.ktp_subdistricts_id;
        this.alamatktp = this.dataEditJSON.ktp_address;
      }else{
        this.kelurahanktp = this.dataEditJSON.ktp_subdistricts_name;
        this.kecamatanktp = this.dataEditJSON.ktp_districts;
        this.kotaktp = this.dataEditJSON.ktp_city;
        this.provinsiktp = this.dataEditJSON.ktp_province;
        this.kodeposktp = this.dataEditJSON.ktp_postal_code;
        this.kelurahanIdktp = this.dataEditJSON.ktp_subdistricts_id;
        this.rtktp = this.dataEditJSON.ktp_rt;
        this.rwktp = this.dataEditJSON.ktp_rw;
        this.alamatktp = this.dataEditJSON.ktp_address;

        this.kelurahandom = this.dataEditJSON.domisili_subdistricts_name;
        this.provinsidom = this.dataEditJSON.domisili_province;
        this.kotadom = this.dataEditJSON.domisili_city;
        this.kecamatandom = this.dataEditJSON.domisili_districts;
        this.kodeposdom = this.dataEditJSON.domisili_postal_code;
        this.alamatdom = this.dataEditJSON.domisili_address;
        this.rtdom = this.dataEditJSON.domisili_rt;
        this.rwdom = this.dataEditJSON.domisili_rw;
        this.kelurahanIddom = this.dataEditJSON.domisili_subdistricts_id;

        if(this.kelurahanIdktp == this.kelurahanIddom){
          this.sesuaiktp = true;
        }else{
          this.sesuaiktp = false;
        }
      }
      } catch (error) {
        
      }
      
    }
    // console.log('kelurahanktp', this.kelurahanktp)
    // console.log('dataEditJSON', this.dataEditJSON)
  }


  changed = (value: any): void => { }
  touched = (): void => { console.log('halo touch'); };

  doInput(event: any) {
    const value = event.target.value;
    this.changed(value);
    this.dataEvent.emit(value);
  }

  registerOnChange(fn: any): void {
    this.changed = fn;
  }

  registerOnTouched(fn: any): void {
    this.touched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(value: any) {
    this.value = value;
  }

  validasi(event: any) {
    const value = event;
    if (this.required == true) {
      if (value == '') {
        this.alertText = true;
      } else {
        this.alertText = false;
      }
    }
  }

  inputCategMobile(){
    // console.log(this.searchCat)
    this.getAllKecamatan();
  }

  clearInput(){
    this.searchCat = '';
    this.getAllKecamatan();
  }

  setOpen(isOpen: boolean) {
    this.openAutoCom = false;
    this.openCategMobile = isOpen;
  }

  setOpenDom(isOpen: boolean) {
    this.openAutoCom = false;
    this.openCategMobileDom = isOpen;
  }

  doInputs(event: any) {
    if(this.tipe == 'satuAlamat'){
    this.dataAlamatString = JSON.stringify({
      "tipe": this.tipe,
      "kelurahanktp" : this.kelurahanktp+' '+this.kecamatanktp+' '+this.kotaktp +' '+ this.provinsiktp,
      "kecamatanktp" : '',
      "kotaktp" : '',
      "provinsiktp" : '',
      "kodeposktp" : '',
      "kelurahanIdktp" : this.kelurahanIdktp,
      "alamatktp" : this.alamatktp,
      "rtktp" : '',
      "rwktp" : '',
    })
  }else{
    this.dataAlamatString = JSON.stringify({
      "tipe": this.tipe,
      "kelurahanktp" : this.kelurahanktp,
      "kecamatanktp" : this.kecamatanktp,
      "kotaktp" : this.kotaktp,
      "provinsiktp" : this.provinsiktp,
      "kodeposktp" : this.kodeposktp,
      "kelurahanIdktp" : this.kelurahanIdktp,
      "alamatktp" : this.alamatktp,
      "rtktp" : this.rtktp,
      "rwktp" : this.rwktp,
      "kelurahandom" : this.kelurahandom,
      "kecamatandom" : this.kecamatandom,
      "kotadom" : this.kotadom,
      "provinsidom" : this.provinsidom,
      "kodeposdom" : this.kodeposdom,
      "kelurahanIddom" : this.kelurahanIddom,
      "alamatdom" : this.alamatdom,
      "rtdom" : this.rtdom,
      "rwdom" : this.rwdom,
    })
  }
    this.dataEvent.emit(this.dataAlamatString);
  }


  pilih(p: any){
    this.kelurahanktp = p.desa_name +', '+  p.kec_name+', '+p.kab_name +', '+ p.prov_name;
    this.kecamatanktp = p.kec_name;
    this.kotaktp = p.kab_name;
    this.provinsiktp = p.prov_name;
    this.kodeposktp = p.kode_pos;
    this.kelurahanIdktp = p.desa_id;
    console.log(p);
    this.setOpen(false);
    this.alertText = false;
    this.dataAlamatString = JSON.stringify({
      "kelurahanktp" : this.kelurahanktp+' '+this.kecamatanktp+' '+this.kotaktp +' '+ this.provinsiktp,
      "kecamatanktp" : this.kecamatanktp,
      "kotaktp" : this.kotaktp,
      "provinsiktp" : this.provinsiktp,
      "kodeposktp" : this.kodeposktp,
      "kelurahanIdktp" : this.kelurahanIdktp,
      "alamatktp" : this.alamatktp,
      "rtktp" : this.rtktp,
      "rwktp" : this.rwktp,

    })
    this.dataEvent.emit(this.dataAlamatString);
  }

  pilihDom(p: any){
    this.kelurahandom = p.desa_name;
    this.kecamatandom = p.kec_name;
    this.kotadom = p.kab_name;
    this.provinsidom = p.prov_name;
    this.kodeposdom = p.kode_pos;
    this.kelurahanIddom = p.desa_id;
    console.log(p);
    this.setOpenDom(false);
    this.alertText = false;
    this.dataAlamatStringDom = JSON.stringify({
      "kelurahandom" : p.desa_name,
      "kecamatandom" : p.kec_name,
      "kotadom" : p.kab_name,
      "provinsidom" : p.prov_name,
      "kodeposdom" : p.kode_pos,
      "kelurahanIddom" : p.desa_id,
      "alamatdom" : this.alamatdom,
      "rtdom" : this.rtdom,
      "rwdom" : this.rwdom,

    })
    this.dataEvent.emit(this.dataAlamatStringDom);
  }

  // doInputsDom(event: any) {
  //   this.dataAlamatStringDom = JSON.stringify({
  //     "kelurahandom" : this.kelurahandom,
  //     "kecamatandom" : this.kecamatandom,
  //     "kotadom" : this.kotadom,
  //     "provinsidom" : this.provinsidom,
  //     "kodeposdom" : this.kodeposdom,
  //     "kelurahanIddom" : this.kelurahanIddom,
  //     "alamatdom" : this.alamatdom,
  //     "rtdom" : this.rtdom,
  //     "rwdom" : this.rwdom,

  //   })
  //   this.dataEvent.emit(this.dataAlamatStringDom);
  // }

  pilihSesuai(event) {
    console.log(event.detail.checked);
    
    if (event.detail.checked == true) {
      this.sesuaiktp = true;
      this.kelurahandom = this.kelurahanktp;
      this.kecamatandom = this.kecamatanktp;
      this.kotadom = this.kotaktp;
      this.provinsidom = this.provinsiktp;
      this.kodeposdom = this.kodeposktp;
      this.rtdom = this.rtktp;
      this.rwdom = this.rwktp;
      this.alamatdom = this.alamatktp;
      this.kelurahanIddom = this.kelurahanIdktp;
    } else {
      // this.dataAlamatKirim = '';
      this.sesuaiktp = false;
      this.kelurahandom = '';
      this.kecamatandom = '';
      this.kotadom = '';
      this.provinsidom = '';
      this.kodeposdom = '';
      this.rtdom = '';
      this.rwdom = '';
      this.alamatdom = '';
    }

  }

  special_char(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  getAllKecamatan() {
    this.load = true;
    let param = {
      q: this.searchCat,
      page: '1',
      limit: '50',
      xsort: 'kab_name',
      xorder: 'desc'
    };
    this.api.post('data/regional', param,)
      .subscribe((data) => {
        this.region = data;
        this.load = false;
        if (this.region.error == 0) {
          this.reg = this.region.data.rows;
          console.log('reg', this.reg);
        } else {
          this.util.showToast(this.region.message, 'danger', 'bottom');
        }
      }, (error) => {
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

}
